/**
 * 排出事業者データ補完
 * 取込
 */
import Vue from "vue";
import * as httpConst from "@/constants/httpConst";

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/transfers/imports`;

const getDefaultState = () => {
  return {}
}

const transferImport = {
  namespaced: true,
  state: getDefaultState(),
  actions: {
    /**
     * 取込処理を行う
     * @param commit
     * @param params {Object} 排出事業者情報
     * @param params.jwnet_manifest_ids {Array} JWNETマニフェスト_ID
     */
    create ({ commit }, { params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.post(API_PATH, params).then( data => {
          if (data.result.message.length <= 0) {
            commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          }
          resolve(data)
        } )
      })
    },

  }
}

export default transferImport;
